module.exports = __webpack_public_path__ + "img/nominee-details.cd31fa2c.svg";